import React from 'react';

type Props = {
    isSelected: boolean;
    onClick: any;
    children: any;
    numberOfChildren: any;
    className?: string;
};

export default function SwitchOption(props: Props) {
    const { onClick, isSelected, numberOfChildren, className } = props;

    return (
        <div
            className={`flex-1 items-center h-12 flex justify-center rounded-full cursor-pointer border-primary-600 ${!isSelected ? "hover:bg-primary-100" : ""}`}
            style={{ width: `calc(${1 / numberOfChildren * 100}%-0.5rem)` }}
            onClick={onClick}
        >
            <div className={`text-center text-sm ${isSelected ? "font-medium" : "text-gray-500"} ${className ?? ""}`}>
                {props.children}
            </div>
        </div>
    );
}